

export function sortAlphabetical(a, b, comparatorAttr: string) {
  if (comparatorAttr) {
    if (a[comparatorAttr] < b[comparatorAttr]) {
      return -1;
    }
    if (a[comparatorAttr] > b[comparatorAttr]) {
      return 1;
    }
    return 0;
  } else {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  }

}
